import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/messaging';

firebase.initializeApp(process.env.FIREBASE_CONFIG);

const db = firebase.database();
const auth = firebase.auth();
const messaging = firebase.messaging();

export {
	db,
	auth,
	messaging
}



// WEBPACK FOOTER //
// ./src/firebase.config.js